<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start-->
<div class="afterLoginPageContainer">
  <div class="mainContent">
    <div class="invitePass p-3">

      <!-- Back button -->
      <div class="backLink" (click)="navigateToList()">
        <i class="fa fa-chevron-left me-3"></i> Back
      </div>

      <!-- Invite content -->
      <ng-container *ngIf="inviteDetails">

        <!-- Visitor / Invitee block -->
        <div class="invite p-3 mt-4 text-center">
          <div class="userlogo mx-auto">
            <img
              [src]="inviteDetails.image_url || 'assets/images/default-profile-individual.png'"
              class="rounded-circle"
              (error)="onImgError($event)"
              alt="Visitor Image"
            />
          </div>

          <div class="info mt-3">
            <h5 class="font-weight-600 mb-0">{{ username }}</h5>
            <p class="mb-0 font-weight-600">{{ userLocation }}</p>
          </div>

          <div class="tktInfo mt-3">
            <h5 class="mb-0 font-weight-600">
             Valid for Single Entry
            </h5>
          </div>
        </div>

        <!-- Exhibitor / Company block -->
        <div class="cmpInfo d-flex align-items-center mt-3 justify-content-center">
          <div class="userlogo">
            <img
              [src]="inviteDetails.invited_by_image_url || 'assets/images/default-profile-individual.png'"
              class="rounded-circle"
              (error)="onImgError($event)"
              alt="Exhibitor Image"
            />
          </div>

          <div class="info ms-3 text-start">
            <p class="mb-0 font-weight-600">Invitation From</p>
            <h5 class="font-weight-600 mb-0">
              {{ inviteDetails.invited_by_organisation_name }}
            </h5>
          </div>
        </div>

        <!-- Accept button -->
        <div class="footBtn mt-4 text-center">
          <button (click)="acceptInvitation()" class="btn">
            Accept Invitation
          </button>
        </div>

      </ng-container>
    </div>
  </div>
</div>